import { LANGUAGES } from '@crehana/ts-types';

import { TTalentUser } from './TalentAuth/hooks/useGetUserData/useGetUserData';

export const getLanguageUser = (
  pathname: string,
  user?: TTalentUser | null,
) => {
  const langEmployee = (
    (user?.language as string) ||
    (user?.company?.language as string) ||
    LANGUAGES.EN
  ).toLowerCase() as LANGUAGES;

  const langAdmin = (
    (user?.company?.language as string) || LANGUAGES.EN
  ).toLowerCase() as LANGUAGES;

  return pathname.split('/')[3] == 'employee' ? langEmployee : langAdmin;
};
